import { 
  Layout,
  Row,
  Col,
  Divider,
  List,
  Icon,
  Button,
  Spin
} from "antd";
import React from 'react';
import { connect } from "react-redux";
import MyModal from '../../Modal';
import { Constant } from "../../../config";
import { Redirect } from 'react-router-dom';
import axios from "axios";
import { 
  setRevisionPriceInfo, 
  setRevisionPriceStep, 
  setRevisionPriceRate, 
  setRevisionLogs,
  setNextRevisionInfo
} from '../../../store/actions/revisionPrice';

class ConfirmRevise extends React.Component  {
  state = {
    loading: false,
    revisionInfo: {},
    revisionLogs: [],
    isCreateRevision: true,
    revisionId: 0,
    redirectToMain: false
  };

  componentDidMount() {
    if (this.props.revisionId !== -1) {
      this.setState({
        revisionId: this.props.revisionId,
        isCreateRevision: false
      })
    }
    this.setState({
      revisionInfo: this.props.revisionInfo,
      revisionLogs: this.props.revisionLogs
    })
  }

  _prevStep = () => {
    this.props.setRevisionPriceStep({
      step: 1
    })
  }

  _saveRevise = () => {
    let prices = []
    this.state.revisionLogs.forEach((item) => {
      prices.push({ country_abbr: item.country_abbr, price: parseFloat(item.new_rate) })
    })
    const { name, note } = this.state.revisionInfo
    let revision = {
      name,
      note,
      prices
    }

    MyModal.confirm(
      'ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?',
      '',
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });
        const modeText = this.state.isCreateRevision ? 'เพิ่ม' : 'แก้ไข';
        const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
        const token = localStorage.getItem(Constant.SessionKey);
        let method = 'PATCH';
        let url = `${Constant.REVISION_PRICE_BY_ID_API.replace("[id]", this.state.revisionId)}`;

        if (this.state.isCreateRevision) {
          method = 'POST';
          url = Constant.REVISION_PRICE_API
        }
        const opt = {
          data: revision,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          method,
          url,
        };

        try {
          await axios(opt);
          this._resetStore();
          MyModal.success(`${modeText}ข้อมูลสำเร็จ`, '', async () => {
            this.setState({ redirectToMain: true })
          });
        } catch (e) {
          let eMsgDetail = '';
          if (e.response && e.response.data && e.response.data.error) {
            const tmp = e.response.data.error;
            eMsgDetail = `[${tmp.code || ''}] ${tmp.name || ''}`;
          }
          MyModal.error(errorMsg, eMsgDetail, async () => {this.setState({ loading: false })});
        }
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  }

  _resetStore = () => {
    this.props.setRevisionPriceInfo({
      version: null,
      name: '',
      note: '',
    });
    this.props.setRevisionPriceRate({
      rate: []
    });
    this.props.setRevisionLogs({
      logs: []
    })
    this.props.setNextRevisionInfo({
      version: '',
      name: '',
      nextVersion: ''
    })
  }
  
  render() {
    const { redirectToMain } = this.state;
     if (redirectToMain) {
       return <Redirect to='/revision-price/listing'/>;
     }

    return (
      <Layout className="section-layout">
        <Divider />
        <Row>
          <Col span={12} offset={6}>
            <h4 style={{ marginBottom: 15, fontWeight: "bold" }}>Revision Information</h4>
            <List bordered className="revision-confirm-list" style={{ marginBottom: 15}}>
              <List.Item key={0}>
                <Row type="flex">
                  <Col span={12} style={{ textAlign: 'center' }}>Version Code</Col>
                  <Col span={12} style={{ fontWeight: "bold", textAlign: 'center' }}>{String(this.state.revisionInfo.version).padStart(4, "0")}</Col>
                </Row>
              </List.Item>
              <List.Item key={1}>
                <Row type="flex">
                  <Col span={12} style={{ textAlign: 'center' }}>Revision Name</Col>
                  <Col span={12} style={{ fontWeight: "bold", textAlign: 'center' }}>{this.state.revisionInfo.name}</Col>
                </Row>
              </List.Item>
              <List.Item key={2}>
                <Row type="flex">
                  <Col span={12} style={{ textAlign: 'center' }}>Revision Note</Col>
                  <Col span={12} style={{ fontWeight: "bold", textAlign: 'center' }}>{this.state.revisionInfo.note || '-'}</Col>
                </Row>
              </List.Item>
            </List>

            <h4 style={{ marginBottom: 15, fontWeight: "bold" }}>Revision Logs</h4>
            <List 
              bordered 
              style={{ marginBottom: 15 }}
              dataSource={this.state.revisionLogs}
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <Row type="flex">
                    <Col span={12} className="text-center">{index + 1}.{item.country_name}</Col>
                    <Col span={12} className="text-center">{item.price.toFixed(4)} <Icon type="arrow-right" /> {item.new_rate}</Col>
                  </Row>
                </List.Item>
              )}
              ></List>
          </Col>
        </Row>
        <Divider />
        <div className="steps-action">
          <Spin spinning={this.state.loading}>
            <Row type="flex" gutter={20} align="middle">
              <Col span={12} className='text-right'>
                <div className="step-link" onClick={() => this._prevStep()}>
                  Back
                </div>
              </Col>
              <Col span={12}>
                <Button type="primary" onClick={() => this._saveRevise()} >
                  Save
                </Button>
              </Col>
            </Row>
          </Spin>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = state => {
	return {
    revisionInfo: state.revisionPrice.info,
		revisionLogs: state.revisionPrice.logs,
    revisionId: state.revisionPrice.id
	}
}

const mapDispatchToProps = dispatch => {
	return {
    setRevisionPriceStep: ({step}) => dispatch(setRevisionPriceStep({step})),
    setRevisionPriceInfo: ({version, name, note}) => dispatch(setRevisionPriceInfo({version, name, note})),
    setRevisionPriceRate: ({rate}) => dispatch(setRevisionPriceRate({rate})),
    setRevisionLogs: ({logs}) => dispatch(setRevisionLogs({logs})),
    setNextRevisionInfo: ({version, name, nextVersion}) => dispatch(setNextRevisionInfo({version, name, nextVersion})),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmRevise);


// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/steps/stepThree.js